import { CommonModule } from "@angular/common";
import { Component, Inject, OnInit } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import {
  MatDialogModule,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { MatTooltipModule } from "@angular/material/tooltip";
import { StorageService } from "src/app/common/services/storage.service";

@Component({
  selector: "app-unsaved-changes-modal",
  templateUrl: "./unsaved-changes-modal.component.html",
  styleUrls: ["./unsaved-changes-modal.component.scss"],
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatTooltipModule],
})
export class UnsavedChangesModal implements OnInit {
  constructor(
    public dialog: MatDialogRef<UnsavedChangesModal>,
    private storageService: StorageService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.dialog.disableClose = true;
    this.dialog.addPanelClass("custom-dialog-container");
    // Save unsaved data before partially logging out the user.
    if(this.storageService.isUserLocked()){
      this.saveAndContinue();
    }
  }

  async saveAndContinue() {
    try {
      await this.data.saveAndContinueAction();
      this.dialog.close(true);
    } catch (err) {}
  }

  async continueWithoutSave() {
    try {
      if(this.data.continueAction)
        this.data?.continueAction();
      this.dialog.close(true);
    } catch (err) {}
  }

  async returnToPage() {
    try {
      if(this.data.returnAction)
        this.data?.returnAction();
      this.dialog.close(false);
    } catch (err) {}
  }

}
